import {types} from './constants';

const {GQL, HTTP, RENDER_START, UPDATE_PROPERTIES, DISPATCH, UPDATE_STATE} = types;

let totalGQL = 0;
let totalHTTP = 0;
let totalRenders = 0;
let totalPropChange = 0;
let totalDispatch = 0;
let totalStateUpdates = 0;

export const getCounters = () => ({
	totalGQL,
	totalHTTP,
	totalRenders,
	totalPropChange,
	totalDispatch,
	totalStateUpdates
});

export const clearCounters = () => {
	totalGQL = 0;
	totalHTTP = 0;
	totalRenders = 0;
	totalPropChange = 0;
	totalDispatch = 0;
	totalStateUpdates = 0;
};

export const increment = type => {
	switch (type) {
		case GQL:
			totalGQL++;
			break;
		case HTTP:
			totalHTTP++;
			break;
		case RENDER_START:
			totalRenders++;
			break;
		case UPDATE_PROPERTIES:
			totalPropChange++;
			break;
		case DISPATCH:
			totalDispatch++;
			break;
		case UPDATE_STATE:
			totalStateUpdates++;
			break;
	}
};
